import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LoginService } from '../services/login.service';
import { ToastService } from '../services/toast.service';

interface LoginForm {
  email: FormControl,
  password: FormControl
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  providers: [MessageService]
})
export class LoginComponent {

  loginForm!: FormGroup<LoginForm>;
  loadingLogin: boolean = false;

  redefinicaoDialog: boolean = false;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private toastService: ToastService
  ){
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)])
    });

    localStorage.clear()
  }

  abreRedefinicaoDialog(){
    this.redefinicaoDialog = true
  }

  escondeRedefinicaoDialog(){
    this.redefinicaoDialog = false;
  }

  submit(){
    this.loadingLogin = true;

    this.loginService.login(this.loginForm.value.email, this.loginForm.value.password).subscribe({
      next: () => {
        // this.messageService.add({severity: 'success', summary: 'Success', detail: 'Login realizado'})
        this.toastService.sucesso('Sucesso', 'Login Realizado')
        this.loadingLogin = false;

        this.router.navigate(["home"])
      },
      error: (value) => {
        this.toastService.erro('Erro', value.error)
        this.loadingLogin = false;
        // this.messageService.add({severity: 'error', summary: 'Erro', detail: value.error })
      }
    })
  }

  getAno(): number {
    return new Date().getFullYear();
  }

}
